import { AVAILABLE_LANGUAGES, DEFAULT_LANG } from 'constants/i18n'
import { Languages } from 'helpers/enum'
import { DAY_NAMES } from 'translations/standalone/calendar'

export const getDayNames = (locale: string) => {
    const calculatedLocale = AVAILABLE_LANGUAGES.includes(locale)
        ? (locale as Languages)
        : DEFAULT_LANG

    const tempArray = [...DAY_NAMES[calculatedLocale].short]

    const lastItem = tempArray.pop()
    if (lastItem) tempArray.unshift(lastItem)

    return tempArray
}
